export default __webpack_public_path__ + "6d7e250cb53f57b4a0795d2b063cafd9.png";